"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailMessageIdentifier = void 0;
var EmailMessageIdentifier;
(function (EmailMessageIdentifier) {
    EmailMessageIdentifier["WELCOME_EMAIL"] = "WELCOME_EMAIL";
    EmailMessageIdentifier["ACCOUNT_CLAIM"] = "ACCOUNT_CLAIM";
    EmailMessageIdentifier["ACCOUNT_RESET"] = "ACCOUNT_RESET";
    EmailMessageIdentifier["ACTIVATION_CODE"] = "ACTIVATION_CODE";
    EmailMessageIdentifier["VERSION_ADOPTION_REPORT"] = "VERSION_ADOPTION_REPORT";
    EmailMessageIdentifier["FAILED_DROPBOX_BACKUP"] = "FAILED_DROPBOX_BACKUP";
    EmailMessageIdentifier["FAILED_GOOGLE_DRIVE_BACKUP"] = "FAILED_GOOGLE_DRIVE_BACKUP";
    EmailMessageIdentifier["FAILED_ONE_DRIVE_BACKUP"] = "FAILED_ONE_DRIVE_BACKUP";
    EmailMessageIdentifier["DATA_BACKUP"] = "DATA_BACKUP";
    EmailMessageIdentifier["FAILED_BACKUP_ATTACHMENT_TOO_BIG"] = "FAILED_BACKUP_ATTACHMENT_TOO_BIG";
    EmailMessageIdentifier["OFFLINE_SUBSCRIPTION_ACCESS"] = "OFFLINE_SUBSCRIPTION_ACCESS";
    EmailMessageIdentifier["SIGN_IN"] = "SIGN_IN";
    EmailMessageIdentifier["SHARED_SUBSCRIPTION_INVITATION"] = "SHARED_SUBSCRIPTION_INVITATION";
    EmailMessageIdentifier["ENCOURAGE_EMAIL_BACKUPS"] = "ENCOURAGE_EMAIL_BACKUPS";
    EmailMessageIdentifier["ENCOURAGE_SUBSCRIPTION_PURCHASING"] = "ENCOURAGE_SUBSCRIPTION_PURCHASING";
    EmailMessageIdentifier["EXIT_INTERVIEW"] = "EXIT_INTERVIEW";
    EmailMessageIdentifier["STUDENT_DISCOUNT_REQUESTED"] = "STUDENT_DISCOUNT_REQUESTED";
    EmailMessageIdentifier["STUDENT_DISCOUNT_APPROVED"] = "STUDENT_DISCOUNT_APPROVED";
    EmailMessageIdentifier["MARKETING_CAMPAIGN_FILES"] = "MARKETING_CAMPAIGN_FILES";
    EmailMessageIdentifier["MARKETING_BLACK_FRIDAY_2022"] = "MARKETING_BLACK_FRIDAY_2022";
    EmailMessageIdentifier["MARKETING_BLACK_FRIDAY_2022_REMINDER"] = "MARKETING_BLACK_FRIDAY_2022_REMINDER";
    EmailMessageIdentifier["PAYMENT_FAILED"] = "PAYMENT_FAILED";
    EmailMessageIdentifier["SEND_INVOICE"] = "SEND_INVOICE";
    EmailMessageIdentifier["DISCOUNT_NOTICE"] = "DISCOUNT_NOTICE";
    EmailMessageIdentifier["REFUND_NOTICE"] = "REFUND_NOTICE";
    EmailMessageIdentifier["REFUND_REQUESTED"] = "REFUND_REQUESTED";
    EmailMessageIdentifier["RATE_ADJUSTMENT_NOTICE"] = "RATE_ADJUSTMENT_NOTICE";
    EmailMessageIdentifier["EXIT_DISCOUNT"] = "EXIT_DISCOUNT";
    EmailMessageIdentifier["SUBSCRIPTION_CANCELLED"] = "SUBSCRIPTION_CANCELLED";
})(EmailMessageIdentifier = exports.EmailMessageIdentifier || (exports.EmailMessageIdentifier = {}));
